import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_CONFIG } from '../../config/config';
import { AppConfig } from '../../config/config.type';
import { Lang } from '../types/lang';

@Injectable({ providedIn: 'root' })
export class LangsService {
  private readonly apiUrl: string;

  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: AppConfig,
    private readonly http: HttpClient,
  ) {
    this.apiUrl = this.appConfig.apiUrl;
  }

  getLangs(): Observable<Lang[]> {
    return this.http.get<Lang[]>([this.apiUrl, 'langs'].join('/'));
  }
}
